import WorkingHoursService from "@/services/api/workingHours";
import { handleResponse } from "@/services/axios";
import { saveAsExcelFile } from "@/services/excelService/excelSevice";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface LoadingState {
    workingHours: boolean;
    workingExport: boolean;
    workingEmailReport: boolean;
}

interface WorkingHoursState {
    workingHoursList: any[];
    loading: LoadingState;
    error: string | null;
}

const initialState: WorkingHoursState = {
    workingHoursList: [],
    loading: {
        workingHours: false,
        workingExport: false,
        workingEmailReport: false,
    },
    error: null,
}


export const getWorkingHours = createAsyncThunk(
    "workingHours/getWorkingHours",
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await WorkingHoursService.getWorkingHours(data);
            return handleResponse(response, rejectWithValue);
        } catch (err: any) {
            return rejectWithValue(
                err?.response?.data?.message || "Failed to fetch working hours",
            );
        }
    },
);

export const getWorkingHoursExportReport = createAsyncThunk(
    "workingHours/getWorkinghoursExport",
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await WorkingHoursService.getWorkingHoursReport(data);
            return saveAsExcelFile(response, "Working_Hours");
        } catch (err: any) {
            return rejectWithValue(
                err?.response?.data?.message || "Failed to export",
            );
        }
    },
);

export const getWorkingHoursEmailReport = createAsyncThunk(
    "workingHours/getWorkingHoursEmailReport",
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await WorkingHoursService.getWorkingHoursEmailReport(data);
            return handleResponse(response, rejectWithValue);
        } catch (err: any) {
            return rejectWithValue(
                err?.response?.data?.message || "Failed to fetch email report",
            );
        }
    },
);

const workingHoursSlice = createSlice({
    name: "workingHours",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getWorkingHours.pending, (state) => {
                state.loading.workingHours = true;
                state.error = null;
                state.workingHoursList = [];
            })
            .addCase(getWorkingHours.fulfilled, (state, action) => {
                state.loading.workingHours = false;
                state.workingHoursList = action.payload || [];
            })
            .addCase(getWorkingHours.rejected, (state, action) => {
                state.loading.workingHours = false;
                state.error = action.payload as string;
            })
            .addCase(getWorkingHoursExportReport.pending, (state) => {
                state.loading.workingExport = true;
                state.error = null;
            })
            .addCase(getWorkingHoursExportReport.fulfilled, (state) => {
                state.loading.workingExport = false;
            })
            .addCase(getWorkingHoursExportReport.rejected, (state, action) => {
                state.loading.workingExport = false;
                state.error = action.payload as string;
            })
            .addCase(getWorkingHoursEmailReport.pending, (state) => {
                state.loading.workingEmailReport = true;
                state.error = null;
            })
            .addCase(getWorkingHoursEmailReport.fulfilled, (state) => {
                state.loading.workingEmailReport = false;
            })
            .addCase(getWorkingHoursEmailReport.rejected, (state, action) => {
                state.loading.workingEmailReport = false;
                state.error = action.payload as string;
            });
    },
});


export default workingHoursSlice.reducer;


